import _ from 'lodash';

import smartSolveApi from './instances/smartsolve';

export function fetchAttachmentFromServer(params) {
  return smartSolveApi.post('/attachmentviewer', _.omit(params, ['action']), {
    responseType: 'blob',
  });
}

export function downloadAllAttachments(params) {
  return smartSolveApi.post('/downloadallattachments', params, {
    responseType: 'blob',
  });
}

export function uploadAttachment(file) {
  const formData = new FormData();

  formData.append('FileName', file.name);
  formData.append('FileDescription', '');
  formData.append('FileStream', file);

  return smartSolveApi.post('/uploadattachment', formData).then((res) => res.data);
}

export const getAttachmentText = async (attachmentId) => {
  try {
    const response = await smartSolveApi.post('/computer-vision/attachment-text', {
      attachmentId,
      formatter: 'html',
    });

    return response.data;
  } catch (e) {
    throw new Error(`getAttachmentText() failed: ${e}`);
  }
};
